<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Farmácia</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  data() {
    return {
      payload: {
        tipoServico: "Farmácia"
      }
    };
  },
  watch: {
    dadosServidor(newVal) {
      if (newVal.servicos.length < 1) return;
      newVal.servicos.forEach(servico => {
        if (servico.tipoServico.tipoServico.includes("Farmácia")) {
          this.clickSwitch = true;
          this.emitPayload({
            ...this.payload,
            clickSwitch: this.clickSwitch
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.procedimentos {
  margin: 1rem 0;
}
</style>
